import { withPlugins, device } from '@spon/plugins';

function SetVh({ plugins: { device } }) {
	let vh = window.innerHeight * 0.01;
	let vw = null;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	function setVertHeight() {
		vw = window.innerWidth;
		vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	setVertHeight();
	device.resize(() => setVertHeight());
}

export default withPlugins(device)(SetVh);
